(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["editorial-grid"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('editorial-grid')) {
  class EditorialGrid extends HTMLElement {
    static plan(entries, mode) {
      const clamp = (value, min, max, fallback) => {
        const number = Number(value);
        return Number.isFinite(number) ? Math.max(min, Math.min(max, Math.trunc(number))) : fallback;
      };
      const items = entries.map((entry, source) => {
        const column = clamp(entry.column, 0, 12, 0);
        return {
          ...entry,
          source: entry.source ?? source,
          column,
          span: clamp(entry.span, 1, column ? 13 - column : 12, 12),
          row: clamp(entry.row, 0, 50, 0),
          rowSpan: clamp(entry.rowSpan, 1, 12, 1),
          order: clamp(entry.order, 0, 50, 0),
          visible: entry.visible !== false,
        };
      }).filter((item) => item.visible);
      const occupied = new Map();
      const placed = new Map();
      const fits = (item, row, column) => {
        if (column + item.span > 13) return false;
        for (let r = row; r < row + item.rowSpan; r++) {
          for (let c = column; c < column + item.span; c++) {
            if (occupied.get(r)?.has(c)) return false;
          }
        }
        return true;
      };
      const put = (item, row, column) => {
        for (let r = row; r < row + item.rowSpan; r++) {
          if (!occupied.has(r)) occupied.set(r, new Set());
          for (let c = column; c < column + item.span; c++) occupied.get(r).add(c);
        }
        const result = { ...item, row, column };
        placed.set(item.source, result);
        return result;
      };
      const findSpace = (item, startRow, startColumn = 1) => {
        let row = startRow;
        let column = item.column || startColumn;
        if (item.column && item.column < startColumn) row++;
        while (!fits(item, row, column)) {
          if (item.column) {
            row++;
          } else {
            column++;
            if (column + item.span > 13) {
              row++;
              column = 1;
            }
          }
        }
        return put(item, row, column);
      };
      if (mode === 'exact') {
        for (const item of items) {
          if (item.row && item.column) put(item, item.row, item.column);
        }
        for (const item of items) {
          if (item.row && !placed.has(item.source)) findSpace(item, item.row);
        }
        for (const item of items) {
          if (!placed.has(item.source)) findSpace(item, 1);
        }
        return [...placed.values()].sort((a, b) => a.row - b.row || a.column - b.column || a.source - b.source);
      }
      const ranks = new Map();
      const taken = new Set();
      const fixed = items.filter((item) => item.order).sort((a, b) => a.order - b.order || a.source - b.source);
      for (const item of fixed) {
        let rank = item.order;
        while (taken.has(rank)) rank++;
        ranks.set(item.source, rank);
        taken.add(rank);
      }
      let freeRank = 1;
      for (const item of [...items].sort((a, b) => a.source - b.source)) {
        if (ranks.has(item.source)) continue;
        while (taken.has(freeRank)) freeRank++;
        ranks.set(item.source, freeRank);
        taken.add(freeRank++);
      }
      items.sort((a, b) => ranks.get(a.source) - ranks.get(b.source));
      let row = 1;
      let column = 1;
      for (const item of items) {
        if (item.newRow && column > 1) {
          row++;
          column = 1;
        }
        const result = findSpace(item, row, column);
        row = result.row;
        column = result.column + result.span;
        if (column > 12) {
          row++;
          column = 1;
        }
      }
      return [...placed.values()];
    }

    connectedCallback() {
      this._abort?.abort();
      this._abort = new AbortController();
      const { signal } = this._abort;
      const query = this.dataset.mobileRule === 'touch'
        ? '(max-width: 749px), (any-pointer: coarse)'
        : '(max-width: 749px)';
      this._media = window.matchMedia(query);
      this._media.addEventListener('change', () => this.refresh(), { signal });
      this._source = new WeakMap();
      this._nextSource = 0;
      this.addEventListener('shopify:block:select', (event) => {
        const item = event.target.closest('[data-eg-item]');
        if (item && this.contains(item) && !item.hidden) {
          item.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'instant' });
        }
      }, { signal });
      this._observer?.disconnect();
      this._observer = new MutationObserver(() => this.refresh());
      queueMicrotask(() => {
        if (this.isConnected) this.refresh();
      });
    }

    disconnectedCallback() {
      this._abort?.abort();
      this._observer?.disconnect();
    }

    refresh() {
      const grid = this.querySelector(':scope > .editorial-grid__shell > .editorial-grid__canvas');
      if (!grid || !this.isConnected) return;
      this._observer.disconnect();
      try {
        const profile = this._media.matches ? 'mobile' : 'desktop';
        const mode = this.dataset[profile === 'mobile' ? 'modeMobile' : 'modeDesktop'];
        const elements = [...grid.children].filter((child) => child.hasAttribute('data-eg-item'));
        let sourceOrder = [];
        try { sourceOrder = JSON.parse(this.dataset.sourceOrder || '[]'); } catch {}
        const entries = elements.map((element) => {
          if (!this._source.has(element)) this._source.set(element, this._nextSource++);
          const canonicalIndex = sourceOrder.indexOf(element.dataset.blockId);
          const source = canonicalIndex >= 0 ? canonicalIndex : sourceOrder.length + this._source.get(element);
          let settings = {};
          try { settings = JSON.parse(element.getAttribute(`data-eg-${profile}`) || '{}'); } catch {}
          return { ...settings, element, source };
        }).sort((a, b) => a.source - b.source);
        const planned = EditorialGrid.plan(entries, mode);
        const visible = new Set(planned.map((entry) => entry.element));
        for (const element of elements) element.hidden = !visible.has(element);
        for (const entry of planned) {
          entry.element.style.setProperty('--eg-resolved-column', entry.column);
          entry.element.style.setProperty('--eg-resolved-row', entry.row);
        }
        const ordered = [...planned.map((entry) => entry.element), ...entries.filter((entry) => !visible.has(entry.element)).map((entry) => entry.element)];
        const focused = document.activeElement;
        let anchor = grid.firstElementChild;
        for (const element of ordered) {
          if (element !== anchor) {
            if (typeof grid.moveBefore === 'function') grid.moveBefore(element, anchor);
            else grid.insertBefore(element, anchor);
          }
          anchor = element.nextElementSibling;
        }
        if (focused instanceof HTMLElement && focused.isConnected && document.activeElement !== focused && !focused.closest('[hidden]')) {
          focused.focus({ preventScroll: true });
        }
        this.dataset.profile = profile;
      } finally {
        this._observer.observe(grid, { childList: true });
      }
    }
  }
  customElements.define('editorial-grid', EditorialGrid);
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
